import React, { useState } from "react";
import Axios from "axios";
import { Button1 } from "../../../Buttons";
import { Spin, Select } from "antd";
import TextInputModal from "../../../TextInputModal";
import { console_error } from "../../../../../helpers/FunctionsGlobal";
const { Option } = Select;

const ChangeOrderRowTemplate = ({
  item_id,
  item_quantity,
  order_id,
  updateOrderRowGoods,
  item_product_price,
  item_product_name,
  onClose,
}) => {
  const [Goods, setGoods] = useState([]);
  const [SearchText, setSearchText] = useState("");
  const [Loading, setLoading] = useState(false);
  const [Timer, setTimer] = useState(0);
  const [SelectedItem, setSelectedItem] = useState(undefined);
  const [errors, setErrors] = useState({});

  const fetchGoods = (value) => {
    setSearchText(value);
    if (Timer) {
      clearTimeout(Timer);
    }
    setTimer(
      setTimeout(() => {
        if (value.length >= 3) {
          setLoading(true);
          Axios.get(
            `/api/v1/products/meilisearch_products?page=1&per_page=25&q[title_or_identifier_i_cont_any]=${value}`
          ).then((response) => {
            if (response.data) {
              const data = response.data.data.map((product) => ({
                quantity: product.quantity,
                product_name: product.title,
                product_price: product.e_price,
                unit_price_tax_incl: product.e_price,
                unit_price_tax_excl: product.e_price,
                product_reference: product.identifier,
                barcode: "",
              }));
              setGoods(data);
              // setSearchText("");
              setLoading(false);
            }
          });
        } else {
          // setSearchText("Minimum 3 characters");
        }
      }, 1000)
    );
  };

  const handleChange = (value) => {
    setSelectedItem({ ...SelectedItem, ...value });
  };
  const onUpdate = async () => {
    try {
      if (!SelectedItem) throw new Error("ERR");
      if (!SelectedItem?.product_name)
        return setErrors((prev) => ({ ...prev, title: "Fill in the field" }));
      const { ok } = await updateOrderRowGoods(
        {
          product_name: SelectedItem.product_name,
          product_price: SelectedItem.product_price,
          quantity: SelectedItem.quantity,
          product_reference: SelectedItem.product_reference,
          unit_price_tax_excl: SelectedItem.unit_price_tax_excl,
          unit_price_tax_incl: SelectedItem.unit_price_tax_incl,
          manual: 1,
        },
        order_id,
        item_id
      );

      if (ok) {
        onClose();
      } else {
        throw new Error("ERR");
      }
    } catch (err) {
      console_error(err);
      return setErrors((prev) => ({ ...prev, error: "Something wrong" }));
    }
  };

  return (
    <div
      style={{
        width: 600,
      }}
    >
      <div className="text-bold mt-1">Replace from</div>
      <div className="d-flex">
        <div style={{ width: "50%" }}>
          <TextInputModal
            text="Name"
            placeholder="Enter"
            value={item_product_name}
            disabled={true}
          />
        </div>
        <div className="px-2" style={{ width: "25%" }}>
          <TextInputModal
            disabled={true}
            type="number"
            text="Quantity"
            placeholder="Enter"
            value={item_quantity}
          />
        </div>
        <div style={{ width: "25%" }}>
          <TextInputModal
            type="number"
            text="Price"
            placeholder="Enter"
            value={item_product_price}
            disabled={true}
          />
        </div>
      </div>
      <div className="text-bold my-1 ">Replace to</div>
      <Select
        showSearch
        // mode="multiple"
        labelInValue
        value={SelectedItem}
        placeholder={"Choose"}
        notFoundContent={
          Loading ? (
            <div className="d-flex justify-content-center">
              <Spin size="small" />
            </div>
          ) : null
        }
        filterOption={false}
        onSearch={fetchGoods}
        onChange={(_, value) =>
          handleChange({ ...value, quantity: item_quantity })
        }
        style={{ width: "100%" }}
      >
        {Goods.map((d, idx) => (
          <Option
            key={`goods_${d.id || "_"}_${idx}`}
            quantity={1}
            product_name={d.product_name}
            product_price={d.product_price}
            unit_price_tax_incl={d.unit_price_tax_incl}
            product_reference={d.product_reference}
            unit_price_tax_excl={d.unit_price_tax_excl}
          >
            {d.product_name}
          </Option>
        ))}
      </Select>
      {SearchText.length >= 1 && SearchText.length < 3 && (
        <p className="text-danger">Minimum 3 characters</p>
      )}

      {typeof SelectedItem !== "undefined" && (
        <React.Fragment>
          <div className="d-flex">
            <div style={{ width: "50%" }}>
              <TextInputModal
                text="Name"
                placeholder="Enter"
                value={SelectedItem.product_name}
                onChange={(e) => handleChange({ product_name: e.target.value })}
                warning={errors.title}
              />
            </div>
            <div className="px-2" style={{ width: "25%" }}>
              <TextInputModal
                type="number"
                text="Quantity"
                placeholder="Enter"
                value={SelectedItem.quantity}
                onChange={(e) => handleChange({ quantity: e.target.value })}
              />
            </div>
            <div style={{ width: "25%" }}>
              <TextInputModal
                type="number"
                text="Price"
                placeholder="Enter"
                value={SelectedItem.unit_price_tax_incl}
                onChange={(e) =>
                  handleChange({ unit_price_tax_incl: e.target.value })
                }
              />
            </div>
          </div>
          {errors.error && <div className="text-danger">{errors.error}</div>}
          <div
            className="my-2"
            style={{ position: "relative", height: "35px" }}
          >
            <Button1
              style={{
                position: "absolute",
                left: "50%",
                transform: "translate(-50%, 0px)",
              }}
              text={"Update"}
              option={"plus"}
              onClick={() => onUpdate()}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default ChangeOrderRowTemplate;
